module.exports = __webpack_public_path__ + "img/premium-currency.6f2dc695.svg";